import { render, staticRenderFns } from "./Esquineros.vue?vue&type=template&id=97f3de86&scoped=true&lang=pug&"
import script from "./Esquineros.vue?vue&type=script&lang=js&"
export * from "./Esquineros.vue?vue&type=script&lang=js&"
import style0 from "./Esquineros.vue?vue&type=style&index=0&id=97f3de86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f3de86",
  null
  
)

export default component.exports